import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import Link from "shared/components/Link";
import isSpa from "shared/util/isSpa";

import LoggedInLinks from "./LoggedInLinks";
import LoggedOutLinks from "./LoggedOutLinks";
import UpgradeLink from "./UpgradeLink";
import ProfileButton from "./ProfileButton";
import BoostButton from "./BoostButton";
import LoggedOut from "./LoggedOut";

import { selectedOptionOnNavBarEvent } from "routers/Desktop/NavBar/components/util/analytics";

import "./NavBar.scss";

const NavBar = ({
	isLoading,
	isLoggedIn,
	displayName,
	thumbnail,
	isStaff,
	isAlist,
	isFlagMod,
	boostTokenCount,
	messagesCount,
	likesCount,
	hasIncognitoEnabled,
	isBoosting,
	boostEndTime,
	boostStartTime,
	multiplier,
	isFinishedBoostModalOpen,
	closeFinishedBoostModal,
	startBoost,
	endBoost,
	location,
}) => {
	const { pathname } = location;

	return (
		<div className={classnames("navbar-container", {
			"navbar-container--is-logged-in": isLoggedIn,
		})}>
			<span className="navbar">
				<h1 className="navbar-logo">
					<Link
						to="/doubletake"
						onClick={() => {
							selectedOptionOnNavBarEvent("discovery");
						}}
						noSpa={!isSpa()}
					>
						<span className="navbar-logo-icon" aria-hidden="true" />
						<span className="navbar-logo-text">OkCupid</span>
					</Link>
				</h1>
				{!isLoading && isLoggedIn && (
					<LoggedInLinks
						pathname={pathname}
						likesCount={likesCount}
						messagesCount={messagesCount}
					/>
				)}
				{!isLoading && !isLoggedIn && (
					<LoggedOutLinks pathname={pathname} />
				)}
			</span>
			<span className="navbar">
				{!isLoading && isLoggedIn &&
					<>
						<ProfileButton
							isAlist={isAlist}
							isFlagMod={isFlagMod}
							displayName={displayName}
							thumbnail={thumbnail}
						/>
						{
							!isAlist && <UpgradeLink />
						}
						<BoostButton
							isStaff={isStaff}
							tokenCount={boostTokenCount}
							hasIncognitoEnabled={hasIncognitoEnabled}
							isBoosting={isBoosting}
							endTime={boostEndTime}
							startTime={boostStartTime}
							multiplier={multiplier}
							isFinishedBoostModalOpen={isFinishedBoostModalOpen}
							closeFinishedBoostModal={closeFinishedBoostModal}
							startBoost={startBoost}
							endBoost={endBoost}
							thumbnail={thumbnail}
						/>
					</>
				}
				{!isLoading && !isLoggedIn &&
					<LoggedOut />
				}
			</span>
		</div>
	);
};

NavBar.propTypes = {
	isLoading: PropTypes.bool,
	isLoggedIn: PropTypes.bool,
	isStaff: PropTypes.bool,
	displayName: PropTypes.string,
	thumbnail: PropTypes.string,
	isAlist: PropTypes.bool,
	isFlagMod: PropTypes.bool,
	boostTokenCount: PropTypes.number,
	messagesCount: PropTypes.number,
	likesCount: PropTypes.oneOfType([
		PropTypes.number,
		PropTypes.string,
	]),
	hasIncognitoEnabled: PropTypes.bool,
	isBoosting: PropTypes.bool,
	boostEndTime: PropTypes.number,
	boostStartTime: PropTypes.number,
	multiplier: PropTypes.number,
	isFinishedBoostModalOpen: PropTypes.bool,
	closeFinishedBoostModal: PropTypes.func.isRequired,
	startBoost: PropTypes.func.isRequired,
	endBoost: PropTypes.func.isRequired,
	location: PropTypes.shape({
		pathname: PropTypes.string.isRequired,
	}),
};

NavBar.defaultProps = {
	isLoading: false,
	isLoggedIn: false,
	isStaff: false,
	displayName: null,
	thumbnail: null,
	isAlist: false,
	isFlagMod: false,
	boostTokenCount: 0,
	messagesCount: null,
	likesCount: null,
	hasIncognitoEnabled: false,
	isBoosting: false,
	boostEndTime: null,
	boostStartTime: null,
	multiplier: 1.1,
	isFinishedBoostModalOpen: false,
	location: window.location,
};

export default NavBar;



// WEBPACK FOOTER //
// ./src/routers/Desktop/NavBar/components/NavBar.jsx